/**
 * The two ends of a detail page's History ROUTE (PROV-AUDIT).
 *
 * History started as a `?view=` mode and converged into a full page —
 * its own ListPage surface, heading, breadcrumb entry, and filters —
 * at which point the router IS the mode mechanism: `…/history` is a
 * sibling route of the details view, so scroll-to-top, breadcrumbs,
 * the close action, and filter-param lifetimes all behave like every
 * other page instead of being special-cased on search state.
 *
 * One spot, two directions: the header control that enters the route
 * is the same spot that leads back out.
 */
import { Link } from 'react-router-dom'
import { buttonVariants, Icon } from '@speaking-coach/ui'

/** The detail page's header action into its history route. */
export function HistoryLink({ to }: { to: string }): JSX.Element {
  return (
    <Link to={to} className={buttonVariants({ variant: 'secondary', size: 'sm' })}>
      <Icon name="history" />
      History
    </Link>
  )
}

/** The history page's header action back to the details view. */
export function BackToDetailsLink({ to }: { to: string }): JSX.Element {
  return (
    <Link to={to} className={buttonVariants({ variant: 'secondary', size: 'sm' })}>
      <Icon name="back" />
      Back to details
    </Link>
  )
}
